export interface ICompanyModel {
  id: string
  name: string
  title: string
  phone: string
  website: string
  logo: string
  background: string
  parentCompanyId: number
  companyType: number
  subCompanies: ICompanyModel[]
  isOwnSystem: boolean
}

const companyInitValues: ICompanyModel = {
  id: '',
  name: '',
  title: '',
  phone: '',
  website: '',
  logo: '',
  background: '',
  parentCompanyId: 0,
  companyType: 0,
  subCompanies: [],
  isOwnSystem: false
}

export {companyInitValues}
